export default __webpack_public_path__ + "static/tooltip-interactive-1-do-light-04978f517955daf028b74db2854534d1660a5555bd4abef423db8ff221f2273a.png";